import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RegistrationData } from '../../model/RegistrationData';
import { BackendService } from './backend.service';
import { CREATE_CHECKOUT_SESSION_REQUEST, NEW_CARD_PURCHASE_AND_REGISTER_REQUEST } from './gql_queries/purchase.gql';

export interface PurchaseInput {
  paymentMethod?: string | null,
  productPrice?: number | null,
  productPriceCurrency?: string | null,
  refNumber?: string | null,

  [key: string]: any | null
}

export interface PurchaseStatus {
  id: string,
  status: string,
  message: string,
  url?: string
}

interface PurchaseStatusFromServer {
  error?: string,
  data?: {
    newPurchaseAndRegister: PurchaseStatus
  }
}

interface CreateCheckoutSessionInput {
  amount: number    //  # 19900 => 199.00
  currency: string // # "pln", "eur", ...
  name: string     //     # np. "Pakiet 100 minut"
  quantity?: number
  orderId?: string
}

interface CreateCheckoutSessionResponse {
  statusCode: number
  url?: string
}

interface CreateCheckoutSessionFromServer {
  error?: string,
  data?: {
    createCheckoutSession: CreateCheckoutSessionResponse
  }
}


@Injectable({
  providedIn: 'root'
})
export class NewPurchaseFormTsService {
  private formData = new BehaviorSubject<RegistrationData>({});
  currentFormData = this.formData.asObservable();

  constructor(
    private readonly backendService: BackendService
  ) {
  }

  updateData(data: RegistrationData): void {
    this.formData.next(data);
  }

  async proceedWithPayment(data: PurchaseInput): Promise<PurchaseStatus> {
    if (!data.productPrice || !data.productPriceCurrency || !data.refNumber) {
      return {
        id: '',
        status: 'error',
        message: 'Missing required fields'
      }
    }
    console.log('newPurchaseAndRegister data:', data,
      'paymentMethod:', data.paymentMethod,
      'productPrice:', data.productPrice
    )
    const result = await this.backendService.executeGraphQL(NEW_CARD_PURCHASE_AND_REGISTER_REQUEST, {
      input: {
        ...data
      }
    }) as PurchaseStatusFromServer;
    if (result.data != null && result.data.newPurchaseAndRegister != null) {
      console.log('newPurchaseAndRegister result:', result.data.newPurchaseAndRegister);
      if (result.data.newPurchaseAndRegister.status.toUpperCase() === 'SUCCESS' && data.paymentMethod === 'creditCard') {
        const ccResult = await this.createCheckoutSession({
          amount: Math.floor(data.productPrice * 100),
          currency: data.productPriceCurrency,
          name: data.refNumber,
          orderId: result.data.newPurchaseAndRegister.id
        });
        if (ccResult.statusCode === 200 && ccResult.url) {
          return {
            ...result.data.newPurchaseAndRegister,
            url: ccResult.url
          }
        } else {
          console.error('Failed to create checkout session:', ccResult);
          return {
            ...result.data.newPurchaseAndRegister,
            status: 'error',
            message: `Failed to create checkout session: ${ccResult.statusCode}`
          }
        }
      } else {
        return result.data.newPurchaseAndRegister;
      }
    }
    return {
      id: '',
      status: 'error',
      message: JSON.stringify(result.error)
    }
  }

  async createCheckoutSession(data: CreateCheckoutSessionInput): Promise<CreateCheckoutSessionResponse> {
    const result = await this.backendService.executeGraphQL(CREATE_CHECKOUT_SESSION_REQUEST, {
      input: {
        ...data
      }
    }) as CreateCheckoutSessionFromServer;
    if (result.data != null && result.data.createCheckoutSession != null) {
      return result.data.createCheckoutSession;
    }
    return {statusCode: 500};
  }
}
